/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.10.1.0 (NJsonSchema v10.3.3.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { PublicClientApplication } from '@azure/msal-browser';
import { getTokenWithRedirectFallback } from '@tq/auth-components';
import { getAuthPaths } from '../auth';
export class IConfig {
  /**
   * Returns a valid value for the Authorization header.
   * Used to dynamically inject the current auth header.
   */
  async getAuthorization() {
    const token = await getTokenWithRedirectFallback(_pca, process.env.REACT_APP_B2C_SCOPE!, getAuthPaths());
    return `Bearer ${token}`;
  }
}

export class AuthorizedApiBase {
  private readonly config: IConfig;

  protected constructor(config: IConfig) {
    this.config = config;
  }

  protected transformOptions = async (options: RequestInit): Promise<RequestInit> => {
    options.headers = {
      ...options.headers,
      Authorization: await this.config.getAuthorization(),
    };
    return Promise.resolve(options);
  };
}

export class Client extends AuthorizedApiBase {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(
    configuration: IConfig,
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    super(configuration);
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param startDate (optional)
   * @param endDate (optional)
   * @param pageNumber (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param fields (optional)
   * @return Get Audits
   */
  getAudits(
    tableName: string | null,
    recordId: string | null,
    startDate: Date | null | undefined,
    endDate: Date | null | undefined,
    pageNumber: number | undefined,
    pageSize: number | undefined,
    orderBy: string | null | undefined,
    fields: string | null | undefined
  ): Promise<SwaggerResponse<AuditRecordDto[]>> {
    let url_ = this.baseUrl + '/api/audits/{tableName}/{recordId}?';
    if (tableName === undefined || tableName === null) throw new Error("The parameter 'tableName' must be defined.");
    url_ = url_.replace('{tableName}', encodeURIComponent('' + tableName));
    if (recordId === undefined || recordId === null) throw new Error("The parameter 'recordId' must be defined.");
    url_ = url_.replace('{recordId}', encodeURIComponent('' + recordId));
    if (startDate !== undefined && startDate !== null)
      url_ += 'StartDate=' + encodeURIComponent(startDate ? '' + startDate.toJSON() : '') + '&';
    if (endDate !== undefined && endDate !== null)
      url_ += 'EndDate=' + encodeURIComponent(endDate ? '' + endDate.toJSON() : '') + '&';
    if (pageNumber === null) throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined) url_ += 'PageNumber=' + encodeURIComponent('' + pageNumber) + '&';
    if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (orderBy !== undefined && orderBy !== null) url_ += 'OrderBy=' + encodeURIComponent('' + orderBy) + '&';
    if (fields !== undefined && fields !== null) url_ += 'Fields=' + encodeURIComponent('' + fields) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAudits(_response);
      });
  }

  protected processGetAudits(response: Response): Promise<SwaggerResponse<AuditRecordDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(AuditRecordDto.fromJS(item));
        }
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponseDto.fromJS(resultData400);
        return throwException('Bad Audit Record', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SwaggerResponse<AuditRecordDto[]>>(new SwaggerResponse(status, _headers, <any>null));
  }

  /**
   * @param pageNumber (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param fields (optional)
   * @return Get Clients List
   */
  getClients(
    pageNumber: number | undefined,
    pageSize: number | undefined,
    orderBy: string | null | undefined,
    fields: string | null | undefined
  ): Promise<SwaggerResponse<ClientsDto[]>> {
    let url_ = this.baseUrl + '/api/clients?';
    if (pageNumber === null) throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined) url_ += 'PageNumber=' + encodeURIComponent('' + pageNumber) + '&';
    if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (orderBy !== undefined && orderBy !== null) url_ += 'OrderBy=' + encodeURIComponent('' + orderBy) + '&';
    if (fields !== undefined && fields !== null) url_ += 'Fields=' + encodeURIComponent('' + fields) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetClients(_response);
      });
  }

  protected processGetClients(response: Response): Promise<SwaggerResponse<ClientsDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(ClientsDto.fromJS(item));
        }
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponseDto.fromJS(resultData404);
        return throwException('Nothing Found', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SwaggerResponse<ClientsDto[]>>(new SwaggerResponse(status, _headers, <any>null));
  }

  /**
   * @param body (optional)
   * @return Create Client
   */
  addClient(body: ClientCreateDto | undefined): Promise<SwaggerResponse<string>> {
    let url_ = this.baseUrl + '/api/clients';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAddClient(_response);
      });
  }

  protected processAddClient(response: Response): Promise<SwaggerResponse<string>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        let resultData201 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result201 = resultData201 !== undefined ? resultData201 : <any>null;
        return new SwaggerResponse(status, _headers, result201);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponseDto.fromJS(resultData400);
        return throwException('Bad Client', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, <any>null));
  }

  /**
   * @return Get Client By Id
   */
  getClient(id: string): Promise<SwaggerResponse<ClientsDto>> {
    let url_ = this.baseUrl + '/api/clients/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetClient(_response);
      });
  }

  protected processGetClient(response: Response): Promise<SwaggerResponse<ClientsDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ClientsDto.fromJS(resultData200);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponseDto.fromJS(resultData404);
        return throwException('Nothing Found', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SwaggerResponse<ClientsDto>>(new SwaggerResponse(status, _headers, <any>null));
  }

  /**
   * @param body (optional)
   * @return Update Client
   */
  updateClient(id: string, body: ClientUpdateDto | undefined): Promise<SwaggerResponse<ClientUpdateDto>> {
    let url_ = this.baseUrl + '/api/clients/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateClient(_response);
      });
  }

  protected processUpdateClient(response: Response): Promise<SwaggerResponse<ClientUpdateDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ClientUpdateDto.fromJS(resultData200);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponseDto.fromJS(resultData400);
        return throwException('Bad Client', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SwaggerResponse<ClientUpdateDto>>(new SwaggerResponse(status, _headers, <any>null));
  }

  /**
   * @return Delete Client By Id
   */
  deleteClient(id: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/clients/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteClient(_response);
      });
  }

  protected processDeleteClient(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponseDto.fromJS(resultData400);
        return throwException('Bad Client', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
  }

  /**
   * @param body (optional)
   * @param file (optional)
   * @return Upload Client Logo
   */
  logo(
    id: string,
    body: Body | undefined,
    file: FileParameter | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + '/api/clients/{id}/logo';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (file !== null && file !== undefined) content_.append('file', file.data, file.fileName ? file.fileName : 'file');

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processLogo(_response);
      });
  }

  protected processLogo(response: Response): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 201) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
      const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponseDto.fromJS(resultData400);
        return throwException('Bad Client Logo', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponseDto.fromJS(resultData404);
        return throwException('Bad Client Logo', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, <any>null));
  }

  /**
   * @param pageNumber (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param fields (optional)
   * @param x_Project_Id Project Id of requested LandParcelId
   * @return Get Documents List
   */
  getDocuments(
    pageNumber: number | undefined,
    pageSize: number | undefined,
    orderBy: string | null | undefined,
    fields: string | null | undefined,
    x_Project_Id: string
  ): Promise<SwaggerResponse<DocumentsDto[]>> {
    let url_ = this.baseUrl + '/api/documents/project?';
    if (pageNumber === null) throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined) url_ += 'PageNumber=' + encodeURIComponent('' + pageNumber) + '&';
    if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (orderBy !== undefined && orderBy !== null) url_ += 'OrderBy=' + encodeURIComponent('' + orderBy) + '&';
    if (fields !== undefined && fields !== null) url_ += 'Fields=' + encodeURIComponent('' + fields) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'X-Project-Id': x_Project_Id !== undefined && x_Project_Id !== null ? '' + x_Project_Id : '',
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetDocuments(_response);
      });
  }

  protected processGetDocuments(response: Response): Promise<SwaggerResponse<DocumentsDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(DocumentsDto.fromJS(item));
        }
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponseDto.fromJS(resultData404);
        return throwException('Nothing Found', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SwaggerResponse<DocumentsDto[]>>(new SwaggerResponse(status, _headers, <any>null));
  }

  /**
   * @param x_Project_Id Project Id of requested LandParcelId
   * @return Document SaS Token By Id
   */
  documentSaSToken(id: string, x_Project_Id: string): Promise<SwaggerResponse<DocumentSasTokenDto>> {
    let url_ = this.baseUrl + '/api/documents/{id}/sas-token';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'X-Project-Id': x_Project_Id !== undefined && x_Project_Id !== null ? '' + x_Project_Id : '',
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDocumentSaSToken(_response);
      });
  }

  protected processDocumentSaSToken(response: Response): Promise<SwaggerResponse<DocumentSasTokenDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = DocumentSasTokenDto.fromJS(resultData200);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponseDto.fromJS(resultData404);
        return throwException('Nothing Found', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SwaggerResponse<DocumentSasTokenDto>>(new SwaggerResponse(status, _headers, <any>null));
  }

  /**
   * @param x_Project_Id Project Id of requested LandParcelId
   * @return Get Area to be Referenced Geometries
   */
  atbr(x_Project_Id: string): Promise<SwaggerResponse<GeoJsonFeatureCollectionDto>> {
    let url_ = this.baseUrl + '/api/geometries/atbr';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'X-Project-Id': x_Project_Id !== undefined && x_Project_Id !== null ? '' + x_Project_Id : '',
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAtbr(_response);
      });
  }

  protected processAtbr(response: Response): Promise<SwaggerResponse<GeoJsonFeatureCollectionDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GeoJsonFeatureCollectionDto.fromJS(resultData200);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponseDto.fromJS(resultData400);
        return throwException('Bad Client', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SwaggerResponse<GeoJsonFeatureCollectionDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * @param boundary (optional)
   * @param x_Project_Id Project Id of requested LandParcelId
   * @return Get Land Parcel Geometries
   */
  parcels(
    boundary: string | null | undefined,
    x_Project_Id: string
  ): Promise<SwaggerResponse<GeoJsonFeatureCollectionDto>> {
    let url_ = this.baseUrl + '/api/geometries/parcels?';
    if (boundary !== undefined && boundary !== null) url_ += 'boundary=' + encodeURIComponent('' + boundary) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'X-Project-Id': x_Project_Id !== undefined && x_Project_Id !== null ? '' + x_Project_Id : '',
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processParcels(_response);
      });
  }

  protected processParcels(response: Response): Promise<SwaggerResponse<GeoJsonFeatureCollectionDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GeoJsonFeatureCollectionDto.fromJS(resultData200);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponseDto.fromJS(resultData400);
        return throwException('Bad Client', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SwaggerResponse<GeoJsonFeatureCollectionDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * @param x_Project_Id Project Id of requested LandParcelId
   * @return Get LandParcel By Id
   */
  getLandParcel(id: string, x_Project_Id: string): Promise<SwaggerResponse<LandParcelsDto>> {
    let url_ = this.baseUrl + '/api/landparcels/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'X-Project-Id': x_Project_Id !== undefined && x_Project_Id !== null ? '' + x_Project_Id : '',
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetLandParcel(_response);
      });
  }

  protected processGetLandParcel(response: Response): Promise<SwaggerResponse<LandParcelsDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = LandParcelsDto.fromJS(resultData200);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponseDto.fromJS(resultData404);
        return throwException('Nothing Found', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SwaggerResponse<LandParcelsDto>>(new SwaggerResponse(status, _headers, <any>null));
  }

  /**
   * @param pageNumber (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param fields (optional)
   * @param x_Project_Id Project Id of requested LandParcelId
   * @return Get Parties By Land Parcel Id
   */
  getLandParcelParties(
    id: string,
    pageNumber: number | undefined,
    pageSize: number | undefined,
    orderBy: string | null | undefined,
    fields: string | null | undefined,
    x_Project_Id: string
  ): Promise<SwaggerResponse<PartiesDto[]>> {
    let url_ = this.baseUrl + '/api/landparcels/{id}/parties?';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    if (pageNumber === null) throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined) url_ += 'PageNumber=' + encodeURIComponent('' + pageNumber) + '&';
    if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (orderBy !== undefined && orderBy !== null) url_ += 'OrderBy=' + encodeURIComponent('' + orderBy) + '&';
    if (fields !== undefined && fields !== null) url_ += 'Fields=' + encodeURIComponent('' + fields) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'X-Project-Id': x_Project_Id !== undefined && x_Project_Id !== null ? '' + x_Project_Id : '',
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetLandParcelParties(_response);
      });
  }

  protected processGetLandParcelParties(response: Response): Promise<SwaggerResponse<PartiesDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(PartiesDto.fromJS(item));
        }
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponseDto.fromJS(resultData404);
        return throwException('Nothing Found', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SwaggerResponse<PartiesDto[]>>(new SwaggerResponse(status, _headers, <any>null));
  }

  /**
   * @param x_Project_Id Project Id of requested LandParcelId
   * @return Get Party By Id
   */
  getParty(partyId: string, x_Project_Id: string): Promise<SwaggerResponse<PartyDto>> {
    let url_ = this.baseUrl + '/api/parties/{partyId}';
    if (partyId === undefined || partyId === null) throw new Error("The parameter 'partyId' must be defined.");
    url_ = url_.replace('{partyId}', encodeURIComponent('' + partyId));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'X-Project-Id': x_Project_Id !== undefined && x_Project_Id !== null ? '' + x_Project_Id : '',
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetParty(_response);
      });
  }

  protected processGetParty(response: Response): Promise<SwaggerResponse<PartyDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PartyDto.fromJS(resultData200);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponseDto.fromJS(resultData404);
        return throwException('Nothing Found', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SwaggerResponse<PartyDto>>(new SwaggerResponse(status, _headers, <any>null));
  }

  /**
   * @param interestTypes (optional)
   * @param pageNumber (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param fields (optional)
   * @param x_Project_Id Project Id of requested LandParcelId
   * @return Get Land Parcels By Party Id
   */
  getPartyLandParcels(
    partyId: string,
    interestTypes: string[] | null | undefined,
    pageNumber: number | undefined,
    pageSize: number | undefined,
    orderBy: string | null | undefined,
    fields: string | null | undefined,
    x_Project_Id: string
  ): Promise<SwaggerResponse<LandParcelDto[]>> {
    let url_ = this.baseUrl + '/api/parties/{partyId}/parcels?';
    if (partyId === undefined || partyId === null) throw new Error("The parameter 'partyId' must be defined.");
    url_ = url_.replace('{partyId}', encodeURIComponent('' + partyId));
    if (interestTypes !== undefined && interestTypes !== null)
      interestTypes &&
        interestTypes.forEach((item) => {
          url_ += 'InterestTypes=' + encodeURIComponent('' + item) + '&';
        });
    if (pageNumber === null) throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined) url_ += 'PageNumber=' + encodeURIComponent('' + pageNumber) + '&';
    if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (orderBy !== undefined && orderBy !== null) url_ += 'OrderBy=' + encodeURIComponent('' + orderBy) + '&';
    if (fields !== undefined && fields !== null) url_ += 'Fields=' + encodeURIComponent('' + fields) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'X-Project-Id': x_Project_Id !== undefined && x_Project_Id !== null ? '' + x_Project_Id : '',
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetPartyLandParcels(_response);
      });
  }

  protected processGetPartyLandParcels(response: Response): Promise<SwaggerResponse<LandParcelDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(LandParcelDto.fromJS(item));
        }
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponseDto.fromJS(resultData404);
        return throwException('Nothing Found', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SwaggerResponse<LandParcelDto[]>>(new SwaggerResponse(status, _headers, <any>null));
  }

  /**
   * @param pageNumber (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param fields (optional)
   * @return Get Projects List
   */
  getProjects(
    pageNumber: number | undefined,
    pageSize: number | undefined,
    orderBy: string | null | undefined,
    fields: string | null | undefined
  ): Promise<SwaggerResponse<ProjectsDto[]>> {
    let url_ = this.baseUrl + '/api/projects?';
    if (pageNumber === null) throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined) url_ += 'PageNumber=' + encodeURIComponent('' + pageNumber) + '&';
    if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (orderBy !== undefined && orderBy !== null) url_ += 'OrderBy=' + encodeURIComponent('' + orderBy) + '&';
    if (fields !== undefined && fields !== null) url_ += 'Fields=' + encodeURIComponent('' + fields) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetProjects(_response);
      });
  }

  protected processGetProjects(response: Response): Promise<SwaggerResponse<ProjectsDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(ProjectsDto.fromJS(item));
        }
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponseDto.fromJS(resultData404);
        return throwException('Nothing Found', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SwaggerResponse<ProjectsDto[]>>(new SwaggerResponse(status, _headers, <any>null));
  }

  /**
   * @param body (optional)
   * @return Create Project
   */
  addProject(body: ProjectCreateDto | undefined): Promise<SwaggerResponse<string>> {
    let url_ = this.baseUrl + '/api/projects';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAddProject(_response);
      });
  }

  protected processAddProject(response: Response): Promise<SwaggerResponse<string>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        let resultData201 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result201 = resultData201 !== undefined ? resultData201 : <any>null;
        return new SwaggerResponse(status, _headers, result201);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponseDto.fromJS(resultData400);
        return throwException('Bad Project', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, <any>null));
  }

  /**
   * @param x_Project_Id Project Id of requested LandParcelId
   * @param body (optional)
   * @return Update Project
   */
  updateProject(x_Project_Id: string, body: ProjectUpdateDto | undefined): Promise<SwaggerResponse<ProjectUpdateDto>> {
    let url_ = this.baseUrl + '/api/projects';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'X-Project-Id': x_Project_Id !== undefined && x_Project_Id !== null ? '' + x_Project_Id : '',
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateProject(_response);
      });
  }

  protected processUpdateProject(response: Response): Promise<SwaggerResponse<ProjectUpdateDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ProjectUpdateDto.fromJS(resultData200);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponseDto.fromJS(resultData400);
        return throwException('Bad Project', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SwaggerResponse<ProjectUpdateDto>>(new SwaggerResponse(status, _headers, <any>null));
  }

  /**
   * @param x_Project_Id Project Id of requested LandParcelId
   * @return Delete Project By Id
   */
  deleteProject(x_Project_Id: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/projects';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {
        'X-Project-Id': x_Project_Id !== undefined && x_Project_Id !== null ? '' + x_Project_Id : '',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteProject(_response);
      });
  }

  protected processDeleteProject(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponseDto.fromJS(resultData400);
        return throwException('Bad Project', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
  }

  /**
   * @param x_Project_Id Project Id of requested LandParcelId
   * @return Get Project By Id
   */
  getProject(x_Project_Id: string): Promise<SwaggerResponse<ProjectsDto>> {
    let url_ = this.baseUrl + '/api/projects/details';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'X-Project-Id': x_Project_Id !== undefined && x_Project_Id !== null ? '' + x_Project_Id : '',
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetProject(_response);
      });
  }

  protected processGetProject(response: Response): Promise<SwaggerResponse<ProjectsDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ProjectsDto.fromJS(resultData200);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponseDto.fromJS(resultData404);
        return throwException('Nothing Found', status, _responseText, _headers, result404);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponseDto.fromJS(resultData400);
        return throwException('Bad Project', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SwaggerResponse<ProjectsDto>>(new SwaggerResponse(status, _headers, <any>null));
  }

  /**
   * @param pageNumber (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param fields (optional)
   * @param x_Project_Id Project Id of requested LandParcelId
   * @return Get Users By Id
   */
  getUsers(
    pageNumber: number | undefined,
    pageSize: number | undefined,
    orderBy: string | null | undefined,
    fields: string | null | undefined,
    x_Project_Id: string
  ): Promise<SwaggerResponse<UsersDto[]>> {
    let url_ = this.baseUrl + '/api/projects/users?';
    if (pageNumber === null) throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined) url_ += 'PageNumber=' + encodeURIComponent('' + pageNumber) + '&';
    if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (orderBy !== undefined && orderBy !== null) url_ += 'OrderBy=' + encodeURIComponent('' + orderBy) + '&';
    if (fields !== undefined && fields !== null) url_ += 'Fields=' + encodeURIComponent('' + fields) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'X-Project-Id': x_Project_Id !== undefined && x_Project_Id !== null ? '' + x_Project_Id : '',
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetUsers(_response);
      });
  }

  protected processGetUsers(response: Response): Promise<SwaggerResponse<UsersDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(UsersDto.fromJS(item));
        }
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponseDto.fromJS(resultData404);
        return throwException('Nothing Found', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SwaggerResponse<UsersDto[]>>(new SwaggerResponse(status, _headers, <any>null));
  }

  /**
   * @param x_Project_Id Project Id of requested LandParcelId
   * @param body (optional)
   * @return Create Project User
   */
  addProjectUser(
    x_Project_Id: string,
    body: ProjectUserCreateDto[] | null | undefined
  ): Promise<SwaggerResponse<string[]>> {
    let url_ = this.baseUrl + '/api/projects/users';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'X-Project-Id': x_Project_Id !== undefined && x_Project_Id !== null ? '' + x_Project_Id : '',
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAddProjectUser(_response);
      });
  }

  protected processAddProjectUser(response: Response): Promise<SwaggerResponse<string[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        let resultData201 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData201)) {
          result201 = [] as any;
          for (let item of resultData201) result201!.push(item);
        }
        return new SwaggerResponse(status, _headers, result201);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ValidationResult.fromJS(resultData400);
        return throwException('Bad Project User', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SwaggerResponse<string[]>>(new SwaggerResponse(status, _headers, <any>null));
  }

  /**
   * @param x_Project_Id Project Id of requested LandParcelId
   * @param body (optional)
   * @return Delete Project User
   */
  deleteProjectUser(x_Project_Id: string, body: string[] | null | undefined): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/projects/users';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: 'DELETE',
      headers: {
        'X-Project-Id': x_Project_Id !== undefined && x_Project_Id !== null ? '' + x_Project_Id : '',
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteProjectUser(_response);
      });
  }

  protected processDeleteProjectUser(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException('Bad Project User', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
  }

  /**
   * @param x_Project_Id Project Id of requested LandParcelId
   * @return Get Project Overview By Id
   */
  getProjectOverview(x_Project_Id: string): Promise<SwaggerResponse<ProjectOverviewDto>> {
    let url_ = this.baseUrl + '/api/projects/overview';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'X-Project-Id': x_Project_Id !== undefined && x_Project_Id !== null ? '' + x_Project_Id : '',
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetProjectOverview(_response);
      });
  }

  protected processGetProjectOverview(response: Response): Promise<SwaggerResponse<ProjectOverviewDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ProjectOverviewDto.fromJS(resultData200);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponseDto.fromJS(resultData404);
        return throwException('Nothing Found', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SwaggerResponse<ProjectOverviewDto>>(new SwaggerResponse(status, _headers, <any>null));
  }

  /**
   * @param x_Project_Id Project Id of requested LandParcelId
   * @return Download Client Logo By Project Id
   */
  downloadClientLogo(x_Project_Id: string): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + '/api/projects/clientlogo';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'X-Project-Id': x_Project_Id !== undefined && x_Project_Id !== null ? '' + x_Project_Id : '',
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDownloadClientLogo(_response);
      });
  }

  protected processDownloadClientLogo(response: Response): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
      const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponseDto.fromJS(resultData400);
        return throwException('Nothing Found', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponseDto.fromJS(resultData404);
        return throwException('Nothing Found', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, <any>null));
  }

  /**
   * @param x_Project_Id Project Id of requested LandParcelId
   * @return Download Project Thumbnail By Id
   */
  downloadProjectThumbnail(x_Project_Id: string): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + '/api/projects/thumbnail';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'X-Project-Id': x_Project_Id !== undefined && x_Project_Id !== null ? '' + x_Project_Id : '',
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDownloadProjectThumbnail(_response);
      });
  }

  protected processDownloadProjectThumbnail(response: Response): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
      const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponseDto.fromJS(resultData400);
        return throwException('Nothing Found', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponseDto.fromJS(resultData404);
        return throwException('Nothing Found', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, <any>null));
  }

  /**
   * @param x_Project_Id Project Id of requested LandParcelId
   * @param body (optional)
   * @param file (optional)
   * @return Upload Project Thumbnail
   */
  thumbnail(
    x_Project_Id: string,
    body: Body2 | undefined,
    file: FileParameter | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + '/api/projects/thumbnail';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (file !== null && file !== undefined) content_.append('file', file.data, file.fileName ? file.fileName : 'file');

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'X-Project-Id': x_Project_Id !== undefined && x_Project_Id !== null ? '' + x_Project_Id : '',
        'Content-Type': 'multipart/form-data',
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processThumbnail(_response);
      });
  }

  protected processThumbnail(response: Response): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 201) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
      const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponseDto.fromJS(resultData400);
        return throwException('Bad Project Thumbnail', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponseDto.fromJS(resultData404);
        return throwException('Bad Project Thumbnail', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, <any>null));
  }

  /**
   * @param searchTerm (optional)
   * @param x_Project_Id Project Id of requested LandParcelId
   * @return Search By Search Term
   */
  search(searchTerm: string | null | undefined, x_Project_Id: string): Promise<SwaggerResponse<SearchDto>> {
    let url_ = this.baseUrl + '/api/search?';
    if (searchTerm !== undefined && searchTerm !== null)
      url_ += 'searchTerm=' + encodeURIComponent('' + searchTerm) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'X-Project-Id': x_Project_Id !== undefined && x_Project_Id !== null ? '' + x_Project_Id : '',
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSearch(_response);
      });
  }

  protected processSearch(response: Response): Promise<SwaggerResponse<SearchDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = SearchDto.fromJS(resultData200);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponseDto.fromJS(resultData400);
        return throwException('Bad Client', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SwaggerResponse<SearchDto>>(new SwaggerResponse(status, _headers, <any>null));
  }

  /**
   * @param x_Project_Id Project Id of requested LandParcelId
   * @return Get SupportingEvidence By Id
   */
  getSupportingEvidence(id: string, x_Project_Id: string): Promise<SwaggerResponse<SupportingEvidencesDto2>> {
    let url_ = this.baseUrl + '/api/supportingevidences/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'X-Project-Id': x_Project_Id !== undefined && x_Project_Id !== null ? '' + x_Project_Id : '',
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetSupportingEvidence(_response);
      });
  }

  protected processGetSupportingEvidence(response: Response): Promise<SwaggerResponse<SupportingEvidencesDto2>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = SupportingEvidencesDto2.fromJS(resultData200);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponseDto.fromJS(resultData404);
        return throwException('Nothing Found', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SwaggerResponse<SupportingEvidencesDto2>>(new SwaggerResponse(status, _headers, <any>null));
  }

  /**
   * @param pageNumber (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param fields (optional)
   * @param x_Project_Id Project Id of requested LandParcelId
   * @return Get Party Supporting Evidences By Id
   */
  getPartySupportingEvidences(
    supportingEvidenceId: string,
    pageNumber: number | undefined,
    pageSize: number | undefined,
    orderBy: string | null | undefined,
    fields: string | null | undefined,
    x_Project_Id: string
  ): Promise<SwaggerResponse<PartySupportingEvidenceDto[]>> {
    let url_ = this.baseUrl + '/api/supportingevidences/{supportingEvidenceId}/parties?';
    if (supportingEvidenceId === undefined || supportingEvidenceId === null)
      throw new Error("The parameter 'supportingEvidenceId' must be defined.");
    url_ = url_.replace('{supportingEvidenceId}', encodeURIComponent('' + supportingEvidenceId));
    if (pageNumber === null) throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined) url_ += 'PageNumber=' + encodeURIComponent('' + pageNumber) + '&';
    if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (orderBy !== undefined && orderBy !== null) url_ += 'OrderBy=' + encodeURIComponent('' + orderBy) + '&';
    if (fields !== undefined && fields !== null) url_ += 'Fields=' + encodeURIComponent('' + fields) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'X-Project-Id': x_Project_Id !== undefined && x_Project_Id !== null ? '' + x_Project_Id : '',
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetPartySupportingEvidences(_response);
      });
  }

  protected processGetPartySupportingEvidences(
    response: Response
  ): Promise<SwaggerResponse<PartySupportingEvidenceDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(PartySupportingEvidenceDto.fromJS(item));
        }
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponseDto.fromJS(resultData404);
        return throwException('Nothing Found', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SwaggerResponse<PartySupportingEvidenceDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * @param x_Project_Id Project Id of requested LandParcelId
   * @return Get Timelines By Project Id
   */
  getTimelines(x_Project_Id: string): Promise<SwaggerResponse<TimelinesDto[]>> {
    let url_ = this.baseUrl + '/api/timelines';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'X-Project-Id': x_Project_Id !== undefined && x_Project_Id !== null ? '' + x_Project_Id : '',
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetTimelines(_response);
      });
  }

  protected processGetTimelines(response: Response): Promise<SwaggerResponse<TimelinesDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(TimelinesDto.fromJS(item));
        }
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponseDto.fromJS(resultData404);
        return throwException('Nothing Found', status, _responseText, _headers, result404);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponseDto.fromJS(resultData400);
        return throwException('Bad Project', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SwaggerResponse<TimelinesDto[]>>(new SwaggerResponse(status, _headers, <any>null));
  }

  /**
   * @param x_Project_Id Project Id of requested LandParcelId
   * @param body (optional)
   * @return Create Timeline
   */
  addTimeline(x_Project_Id: string, body: TimelineCreateUpdateDto | undefined): Promise<SwaggerResponse<string>> {
    let url_ = this.baseUrl + '/api/timelines';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'X-Project-Id': x_Project_Id !== undefined && x_Project_Id !== null ? '' + x_Project_Id : '',
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAddTimeline(_response);
      });
  }

  protected processAddTimeline(response: Response): Promise<SwaggerResponse<string>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        let resultData201 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result201 = resultData201 !== undefined ? resultData201 : <any>null;
        return new SwaggerResponse(status, _headers, result201);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponseDto.fromJS(resultData400);
        return throwException('Bad Timeline', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, <any>null));
  }

  /**
   * @param x_Project_Id Project Id of requested LandParcelId
   * @param body (optional)
   * @return Update Timeline
   */
  updateTimeline(
    timelineRecordId: string,
    x_Project_Id: string,
    body: TimelineCreateUpdateDto | undefined
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/timelines/{timelineRecordId}';
    if (timelineRecordId === undefined || timelineRecordId === null)
      throw new Error("The parameter 'timelineRecordId' must be defined.");
    url_ = url_.replace('{timelineRecordId}', encodeURIComponent('' + timelineRecordId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: 'PUT',
      headers: {
        'X-Project-Id': x_Project_Id !== undefined && x_Project_Id !== null ? '' + x_Project_Id : '',
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateTimeline(_response);
      });
  }

  protected processUpdateTimeline(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponseDto.fromJS(resultData400);
        return throwException('Bad Timeline', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponseDto.fromJS(resultData404);
        return throwException('Nothing Found', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
  }

  /**
   * @param x_Project_Id Project Id of requested LandParcelId
   * @return Delete Timeline By Id
   */
  deleteTimeline(timelineRecordId: string, x_Project_Id: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/api/timelines/{timelineRecordId}';
    if (timelineRecordId === undefined || timelineRecordId === null)
      throw new Error("The parameter 'timelineRecordId' must be defined.");
    url_ = url_.replace('{timelineRecordId}', encodeURIComponent('' + timelineRecordId));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {
        'X-Project-Id': x_Project_Id !== undefined && x_Project_Id !== null ? '' + x_Project_Id : '',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteTimeline(_response);
      });
  }

  protected processDeleteTimeline(response: Response): Promise<SwaggerResponse<void>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ErrorResponseDto.fromJS(resultData400);
        return throwException('Bad Timeline', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponseDto.fromJS(resultData404);
        return throwException('Nothing Found', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
  }
}

export class AuditRecordDto implements IAuditRecordDto {
  id?: number;
  environment?: { [key: string]: string } | undefined;
  startDate?: Date;
  endDate?: Date;
  duration?: number;
  recordId?: string;
  tableName?: string | undefined;
  eventType?: string | undefined;
  type?: string | undefined;
  old?: { [key: string]: string } | undefined;
  new?: { [key: string]: string } | undefined;
  userId?: string;

  constructor(data?: IAuditRecordDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      if (_data['environment']) {
        this.environment = {} as any;
        for (let key in _data['environment']) {
          if (_data['environment'].hasOwnProperty(key)) this.environment![key] = _data['environment'][key];
        }
      }
      this.startDate = _data['startDate'] ? new Date(_data['startDate'].toString()) : <any>undefined;
      this.endDate = _data['endDate'] ? new Date(_data['endDate'].toString()) : <any>undefined;
      this.duration = _data['duration'];
      this.recordId = _data['recordId'];
      this.tableName = _data['tableName'];
      this.eventType = _data['eventType'];
      this.type = _data['type'];
      if (_data['old']) {
        this.old = {} as any;
        for (let key in _data['old']) {
          if (_data['old'].hasOwnProperty(key)) this.old![key] = _data['old'][key];
        }
      }
      if (_data['new']) {
        this.new = {} as any;
        for (let key in _data['new']) {
          if (_data['new'].hasOwnProperty(key)) this.new![key] = _data['new'][key];
        }
      }
      this.userId = _data['userId'];
    }
  }

  static fromJS(data: any): AuditRecordDto {
    data = typeof data === 'object' ? data : {};
    let result = new AuditRecordDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    if (this.environment) {
      data['environment'] = {};
      for (let key in this.environment) {
        if (this.environment.hasOwnProperty(key)) data['environment'][key] = this.environment[key];
      }
    }
    data['startDate'] = this.startDate ? this.startDate.toISOString() : <any>undefined;
    data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>undefined;
    data['duration'] = this.duration;
    data['recordId'] = this.recordId;
    data['tableName'] = this.tableName;
    data['eventType'] = this.eventType;
    data['type'] = this.type;
    if (this.old) {
      data['old'] = {};
      for (let key in this.old) {
        if (this.old.hasOwnProperty(key)) data['old'][key] = this.old[key];
      }
    }
    if (this.new) {
      data['new'] = {};
      for (let key in this.new) {
        if (this.new.hasOwnProperty(key)) data['new'][key] = this.new[key];
      }
    }
    data['userId'] = this.userId;
    return data;
  }
}

export interface IAuditRecordDto {
  id?: number;
  environment?: { [key: string]: string } | undefined;
  startDate?: Date;
  endDate?: Date;
  duration?: number;
  recordId?: string;
  tableName?: string | undefined;
  eventType?: string | undefined;
  type?: string | undefined;
  old?: { [key: string]: string } | undefined;
  new?: { [key: string]: string } | undefined;
  userId?: string;
}

export class ErrorResponseDto implements IErrorResponseDto {
  error?: boolean;
  statusCode?: number;
  errorCode?: string | undefined;
  message?: string | undefined;
  debugMessage?: string | undefined;

  constructor(data?: IErrorResponseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.error = _data['error'];
      this.statusCode = _data['statusCode'];
      this.errorCode = _data['errorCode'];
      this.message = _data['message'];
      this.debugMessage = _data['debugMessage'];
    }
  }

  static fromJS(data: any): ErrorResponseDto {
    data = typeof data === 'object' ? data : {};
    let result = new ErrorResponseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['error'] = this.error;
    data['statusCode'] = this.statusCode;
    data['errorCode'] = this.errorCode;
    data['message'] = this.message;
    data['debugMessage'] = this.debugMessage;
    return data;
  }
}

export interface IErrorResponseDto {
  error?: boolean;
  statusCode?: number;
  errorCode?: string | undefined;
  message?: string | undefined;
  debugMessage?: string | undefined;
}

export class ClientsDto implements IClientsDto {
  id?: string;
  name?: string | undefined;

  constructor(data?: IClientsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): ClientsDto {
    data = typeof data === 'object' ? data : {};
    let result = new ClientsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    return data;
  }
}

export interface IClientsDto {
  id?: string;
  name?: string | undefined;
}

export class ClientCreateDto implements IClientCreateDto {
  id?: string;
  name?: string | undefined;
  storageURL?: string | undefined;
  storageContainer?: string | undefined;

  constructor(data?: IClientCreateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.storageURL = _data['storageURL'];
      this.storageContainer = _data['storageContainer'];
    }
  }

  static fromJS(data: any): ClientCreateDto {
    data = typeof data === 'object' ? data : {};
    let result = new ClientCreateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['storageURL'] = this.storageURL;
    data['storageContainer'] = this.storageContainer;
    return data;
  }
}

export interface IClientCreateDto {
  id?: string;
  name?: string | undefined;
  storageURL?: string | undefined;
  storageContainer?: string | undefined;
}

export class ClientUpdateDto implements IClientUpdateDto {
  name?: string | undefined;
  storageURL?: string | undefined;
  storageContainer?: string | undefined;

  constructor(data?: IClientUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.storageURL = _data['storageURL'];
      this.storageContainer = _data['storageContainer'];
    }
  }

  static fromJS(data: any): ClientUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new ClientUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['storageURL'] = this.storageURL;
    data['storageContainer'] = this.storageContainer;
    return data;
  }
}

export interface IClientUpdateDto {
  name?: string | undefined;
  storageURL?: string | undefined;
  storageContainer?: string | undefined;
}

export class DocumentsDto implements IDocumentsDto {
  id?: string;
  reference?: string | undefined;
  clientReference?: string | undefined;
  type?: string | undefined;
  version?: string | undefined;
  documentURL?: string | undefined;

  constructor(data?: IDocumentsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.reference = _data['reference'];
      this.clientReference = _data['clientReference'];
      this.type = _data['type'];
      this.version = _data['version'];
      this.documentURL = _data['documentURL'];
    }
  }

  static fromJS(data: any): DocumentsDto {
    data = typeof data === 'object' ? data : {};
    let result = new DocumentsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['reference'] = this.reference;
    data['clientReference'] = this.clientReference;
    data['type'] = this.type;
    data['version'] = this.version;
    data['documentURL'] = this.documentURL;
    return data;
  }
}

export interface IDocumentsDto {
  id?: string;
  reference?: string | undefined;
  clientReference?: string | undefined;
  type?: string | undefined;
  version?: string | undefined;
  documentURL?: string | undefined;
}

export class DocumentSasTokenDto implements IDocumentSasTokenDto {
  uri?: string | undefined;

  constructor(data?: IDocumentSasTokenDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.uri = _data['uri'];
    }
  }

  static fromJS(data: any): DocumentSasTokenDto {
    data = typeof data === 'object' ? data : {};
    let result = new DocumentSasTokenDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['uri'] = this.uri;
    return data;
  }
}

export interface IDocumentSasTokenDto {
  uri?: string | undefined;
}

export class GeoJsonGeometryDto implements IGeoJsonGeometryDto {
  type?: string | undefined;
  coordinates?: number[][][] | undefined;

  constructor(data?: IGeoJsonGeometryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data['type'];
      if (Array.isArray(_data['coordinates'])) {
        this.coordinates = [] as any;
        for (let item of _data['coordinates']) this.coordinates!.push(item);
      }
    }
  }

  static fromJS(data: any): GeoJsonGeometryDto {
    data = typeof data === 'object' ? data : {};
    let result = new GeoJsonGeometryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['type'] = this.type;
    if (Array.isArray(this.coordinates)) {
      data['coordinates'] = [];
      for (let item of this.coordinates) data['coordinates'].push(item);
    }
    return data;
  }
}

export interface IGeoJsonGeometryDto {
  type?: string | undefined;
  coordinates?: number[][][] | undefined;
}

export class GeoJsonPropertiesDto implements IGeoJsonPropertiesDto {
  name?: string | undefined;

  constructor(data?: IGeoJsonPropertiesDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): GeoJsonPropertiesDto {
    data = typeof data === 'object' ? data : {};
    let result = new GeoJsonPropertiesDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    return data;
  }
}

export interface IGeoJsonPropertiesDto {
  name?: string | undefined;
}

export class GeoJsonFeatureDto implements IGeoJsonFeatureDto {
  type?: string | undefined;
  id?: string | undefined;
  geometry?: GeoJsonGeometryDto;
  properties?: GeoJsonPropertiesDto;

  constructor(data?: IGeoJsonFeatureDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data['type'];
      this.id = _data['id'];
      this.geometry = _data['geometry'] ? GeoJsonGeometryDto.fromJS(_data['geometry']) : <any>undefined;
      this.properties = _data['properties'] ? GeoJsonPropertiesDto.fromJS(_data['properties']) : <any>undefined;
    }
  }

  static fromJS(data: any): GeoJsonFeatureDto {
    data = typeof data === 'object' ? data : {};
    let result = new GeoJsonFeatureDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['type'] = this.type;
    data['id'] = this.id;
    data['geometry'] = this.geometry ? this.geometry.toJSON() : <any>undefined;
    data['properties'] = this.properties ? this.properties.toJSON() : <any>undefined;
    return data;
  }
}

export interface IGeoJsonFeatureDto {
  type?: string | undefined;
  id?: string | undefined;
  geometry?: GeoJsonGeometryDto;
  properties?: GeoJsonPropertiesDto;
}

export class GeoJsonFeatureCollectionDto implements IGeoJsonFeatureCollectionDto {
  type?: string | undefined;
  features?: GeoJsonFeatureDto[] | undefined;

  constructor(data?: IGeoJsonFeatureCollectionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data['type'];
      if (Array.isArray(_data['features'])) {
        this.features = [] as any;
        for (let item of _data['features']) this.features!.push(GeoJsonFeatureDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GeoJsonFeatureCollectionDto {
    data = typeof data === 'object' ? data : {};
    let result = new GeoJsonFeatureCollectionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['type'] = this.type;
    if (Array.isArray(this.features)) {
      data['features'] = [];
      for (let item of this.features) data['features'].push(item.toJSON());
    }
    return data;
  }
}

export interface IGeoJsonFeatureCollectionDto {
  type?: string | undefined;
  features?: GeoJsonFeatureDto[] | undefined;
}

export class LandParcelsDto implements ILandParcelsDto {
  id?: string;
  reference?: string | undefined;
  clientReference?: string | undefined;
  numberOnPlan?: string | undefined;
  description?: string | undefined;

  constructor(data?: ILandParcelsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.reference = _data['reference'];
      this.clientReference = _data['clientReference'];
      this.numberOnPlan = _data['numberOnPlan'];
      this.description = _data['description'];
    }
  }

  static fromJS(data: any): LandParcelsDto {
    data = typeof data === 'object' ? data : {};
    let result = new LandParcelsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['reference'] = this.reference;
    data['clientReference'] = this.clientReference;
    data['numberOnPlan'] = this.numberOnPlan;
    data['description'] = this.description;
    return data;
  }
}

export interface ILandParcelsDto {
  id?: string;
  reference?: string | undefined;
  clientReference?: string | undefined;
  numberOnPlan?: string | undefined;
  description?: string | undefined;
}

export class SupportingEvidencesDto implements ISupportingEvidencesDto {
  id?: string;
  direction?: string | undefined;
  supportingEvidenceReference?: string | undefined;

  constructor(data?: ISupportingEvidencesDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.direction = _data['direction'];
      this.supportingEvidenceReference = _data['supportingEvidenceReference'];
    }
  }

  static fromJS(data: any): SupportingEvidencesDto {
    data = typeof data === 'object' ? data : {};
    let result = new SupportingEvidencesDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['direction'] = this.direction;
    data['supportingEvidenceReference'] = this.supportingEvidenceReference;
    return data;
  }
}

export interface ISupportingEvidencesDto {
  id?: string;
  direction?: string | undefined;
  supportingEvidenceReference?: string | undefined;
}

export class InterestsDto implements IInterestsDto {
  id?: string;
  description?: string | undefined;
  status?: string | undefined;
  type?: string | undefined;
  partyInterestId?: string;
  partyInterestCapacity?: string | undefined;
  partyInterestDisplaySequence?: string | undefined;
  partyInterestStatus?: string | undefined;
  supportingEvidences?: SupportingEvidencesDto[] | undefined;

  constructor(data?: IInterestsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.description = _data['description'];
      this.status = _data['status'];
      this.type = _data['type'];
      this.partyInterestId = _data['partyInterestId'];
      this.partyInterestCapacity = _data['partyInterestCapacity'];
      this.partyInterestDisplaySequence = _data['partyInterestDisplaySequence'];
      this.partyInterestStatus = _data['partyInterestStatus'];
      if (Array.isArray(_data['supportingEvidences'])) {
        this.supportingEvidences = [] as any;
        for (let item of _data['supportingEvidences'])
          this.supportingEvidences!.push(SupportingEvidencesDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): InterestsDto {
    data = typeof data === 'object' ? data : {};
    let result = new InterestsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['description'] = this.description;
    data['status'] = this.status;
    data['type'] = this.type;
    data['partyInterestId'] = this.partyInterestId;
    data['partyInterestCapacity'] = this.partyInterestCapacity;
    data['partyInterestDisplaySequence'] = this.partyInterestDisplaySequence;
    data['partyInterestStatus'] = this.partyInterestStatus;
    if (Array.isArray(this.supportingEvidences)) {
      data['supportingEvidences'] = [];
      for (let item of this.supportingEvidences) data['supportingEvidences'].push(item.toJSON());
    }
    return data;
  }
}

export interface IInterestsDto {
  id?: string;
  description?: string | undefined;
  status?: string | undefined;
  type?: string | undefined;
  partyInterestId?: string;
  partyInterestCapacity?: string | undefined;
  partyInterestDisplaySequence?: string | undefined;
  partyInterestStatus?: string | undefined;
  supportingEvidences?: SupportingEvidencesDto[] | undefined;
}

export class AddressesDto implements IAddressesDto {
  id?: string;
  addressLine1?: string | undefined;
  addressLine2?: string | undefined;
  addressLine3?: string | undefined;
  addressLine4?: string | undefined;
  addressLine5?: string | undefined;
  addressLine6?: string | undefined;
  postalTown?: string | undefined;
  postCode?: string | undefined;
  country?: string | undefined;
  type?: string | undefined;
  status?: string | undefined;

  constructor(data?: IAddressesDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.addressLine1 = _data['addressLine1'];
      this.addressLine2 = _data['addressLine2'];
      this.addressLine3 = _data['addressLine3'];
      this.addressLine4 = _data['addressLine4'];
      this.addressLine5 = _data['addressLine5'];
      this.addressLine6 = _data['addressLine6'];
      this.postalTown = _data['postalTown'];
      this.postCode = _data['postCode'];
      this.country = _data['country'];
      this.type = _data['type'];
      this.status = _data['status'];
    }
  }

  static fromJS(data: any): AddressesDto {
    data = typeof data === 'object' ? data : {};
    let result = new AddressesDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['addressLine1'] = this.addressLine1;
    data['addressLine2'] = this.addressLine2;
    data['addressLine3'] = this.addressLine3;
    data['addressLine4'] = this.addressLine4;
    data['addressLine5'] = this.addressLine5;
    data['addressLine6'] = this.addressLine6;
    data['postalTown'] = this.postalTown;
    data['postCode'] = this.postCode;
    data['country'] = this.country;
    data['type'] = this.type;
    data['status'] = this.status;
    return data;
  }
}

export interface IAddressesDto {
  id?: string;
  addressLine1?: string | undefined;
  addressLine2?: string | undefined;
  addressLine3?: string | undefined;
  addressLine4?: string | undefined;
  addressLine5?: string | undefined;
  addressLine6?: string | undefined;
  postalTown?: string | undefined;
  postCode?: string | undefined;
  country?: string | undefined;
  type?: string | undefined;
  status?: string | undefined;
}

export class PartiesDto implements IPartiesDto {
  id?: string;
  projectId?: string;
  reference?: string | undefined;
  principalName?: string | undefined;
  isOrganisation?: boolean;
  title?: string | undefined;
  topo?: string | undefined;
  salutation?: string | undefined;
  status?: string | undefined;
  interests?: InterestsDto[] | undefined;
  addresses?: AddressesDto[] | undefined;

  constructor(data?: IPartiesDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.projectId = _data['projectId'];
      this.reference = _data['reference'];
      this.principalName = _data['principalName'];
      this.isOrganisation = _data['isOrganisation'];
      this.title = _data['title'];
      this.topo = _data['topo'];
      this.salutation = _data['salutation'];
      this.status = _data['status'];
      if (Array.isArray(_data['interests'])) {
        this.interests = [] as any;
        for (let item of _data['interests']) this.interests!.push(InterestsDto.fromJS(item));
      }
      if (Array.isArray(_data['addresses'])) {
        this.addresses = [] as any;
        for (let item of _data['addresses']) this.addresses!.push(AddressesDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PartiesDto {
    data = typeof data === 'object' ? data : {};
    let result = new PartiesDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['projectId'] = this.projectId;
    data['reference'] = this.reference;
    data['principalName'] = this.principalName;
    data['isOrganisation'] = this.isOrganisation;
    data['title'] = this.title;
    data['topo'] = this.topo;
    data['salutation'] = this.salutation;
    data['status'] = this.status;
    if (Array.isArray(this.interests)) {
      data['interests'] = [];
      for (let item of this.interests) data['interests'].push(item.toJSON());
    }
    if (Array.isArray(this.addresses)) {
      data['addresses'] = [];
      for (let item of this.addresses) data['addresses'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPartiesDto {
  id?: string;
  projectId?: string;
  reference?: string | undefined;
  principalName?: string | undefined;
  isOrganisation?: boolean;
  title?: string | undefined;
  topo?: string | undefined;
  salutation?: string | undefined;
  status?: string | undefined;
  interests?: InterestsDto[] | undefined;
  addresses?: AddressesDto[] | undefined;
}

export class AddressDto implements IAddressDto {
  id?: string;
  addressLine1?: string | undefined;
  addressLine2?: string | undefined;
  addressLine3?: string | undefined;
  addressLine4?: string | undefined;
  addressLine5?: string | undefined;
  addressLine6?: string | undefined;
  postalTown?: string | undefined;
  postCode?: string | undefined;
  country?: string | undefined;
  status?: string | undefined;
  type?: string | undefined;

  constructor(data?: IAddressDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.addressLine1 = _data['addressLine1'];
      this.addressLine2 = _data['addressLine2'];
      this.addressLine3 = _data['addressLine3'];
      this.addressLine4 = _data['addressLine4'];
      this.addressLine5 = _data['addressLine5'];
      this.addressLine6 = _data['addressLine6'];
      this.postalTown = _data['postalTown'];
      this.postCode = _data['postCode'];
      this.country = _data['country'];
      this.status = _data['status'];
      this.type = _data['type'];
    }
  }

  static fromJS(data: any): AddressDto {
    data = typeof data === 'object' ? data : {};
    let result = new AddressDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['addressLine1'] = this.addressLine1;
    data['addressLine2'] = this.addressLine2;
    data['addressLine3'] = this.addressLine3;
    data['addressLine4'] = this.addressLine4;
    data['addressLine5'] = this.addressLine5;
    data['addressLine6'] = this.addressLine6;
    data['postalTown'] = this.postalTown;
    data['postCode'] = this.postCode;
    data['country'] = this.country;
    data['status'] = this.status;
    data['type'] = this.type;
    return data;
  }
}

export interface IAddressDto {
  id?: string;
  addressLine1?: string | undefined;
  addressLine2?: string | undefined;
  addressLine3?: string | undefined;
  addressLine4?: string | undefined;
  addressLine5?: string | undefined;
  addressLine6?: string | undefined;
  postalTown?: string | undefined;
  postCode?: string | undefined;
  country?: string | undefined;
  status?: string | undefined;
  type?: string | undefined;
}

export class PartyDto implements IPartyDto {
  id?: string;
  projectId?: string;
  reference?: string | undefined;
  principalName?: string | undefined;
  isOrganisation?: boolean;
  topo?: string | undefined;
  salutation?: string | undefined;
  title?: string | undefined;
  status?: string | undefined;
  addresses?: AddressDto[] | undefined;

  constructor(data?: IPartyDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.projectId = _data['projectId'];
      this.reference = _data['reference'];
      this.principalName = _data['principalName'];
      this.isOrganisation = _data['isOrganisation'];
      this.topo = _data['topo'];
      this.salutation = _data['salutation'];
      this.title = _data['title'];
      this.status = _data['status'];
      if (Array.isArray(_data['addresses'])) {
        this.addresses = [] as any;
        for (let item of _data['addresses']) this.addresses!.push(AddressDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PartyDto {
    data = typeof data === 'object' ? data : {};
    let result = new PartyDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['projectId'] = this.projectId;
    data['reference'] = this.reference;
    data['principalName'] = this.principalName;
    data['isOrganisation'] = this.isOrganisation;
    data['topo'] = this.topo;
    data['salutation'] = this.salutation;
    data['title'] = this.title;
    data['status'] = this.status;
    if (Array.isArray(this.addresses)) {
      data['addresses'] = [];
      for (let item of this.addresses) data['addresses'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPartyDto {
  id?: string;
  projectId?: string;
  reference?: string | undefined;
  principalName?: string | undefined;
  isOrganisation?: boolean;
  topo?: string | undefined;
  salutation?: string | undefined;
  title?: string | undefined;
  status?: string | undefined;
  addresses?: AddressDto[] | undefined;
}

export class SupportingEvidenceDto implements ISupportingEvidenceDto {
  id?: string;
  direction?: string | undefined;
  supportingEvidenceReference?: string | undefined;

  constructor(data?: ISupportingEvidenceDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.direction = _data['direction'];
      this.supportingEvidenceReference = _data['supportingEvidenceReference'];
    }
  }

  static fromJS(data: any): SupportingEvidenceDto {
    data = typeof data === 'object' ? data : {};
    let result = new SupportingEvidenceDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['direction'] = this.direction;
    data['supportingEvidenceReference'] = this.supportingEvidenceReference;
    return data;
  }
}

export interface ISupportingEvidenceDto {
  id?: string;
  direction?: string | undefined;
  supportingEvidenceReference?: string | undefined;
}

export class InterestDto implements IInterestDto {
  id?: string;
  type?: string | undefined;
  status?: string | undefined;
  description?: string | undefined;
  partyInterestCapacity?: string | undefined;
  partyInterestStatus?: string | undefined;
  partyInterestDisplaySequence?: number;
  supportingEvidences?: SupportingEvidenceDto[] | undefined;

  constructor(data?: IInterestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.type = _data['type'];
      this.status = _data['status'];
      this.description = _data['description'];
      this.partyInterestCapacity = _data['partyInterestCapacity'];
      this.partyInterestStatus = _data['partyInterestStatus'];
      this.partyInterestDisplaySequence = _data['partyInterestDisplaySequence'];
      if (Array.isArray(_data['supportingEvidences'])) {
        this.supportingEvidences = [] as any;
        for (let item of _data['supportingEvidences'])
          this.supportingEvidences!.push(SupportingEvidenceDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): InterestDto {
    data = typeof data === 'object' ? data : {};
    let result = new InterestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['type'] = this.type;
    data['status'] = this.status;
    data['description'] = this.description;
    data['partyInterestCapacity'] = this.partyInterestCapacity;
    data['partyInterestStatus'] = this.partyInterestStatus;
    data['partyInterestDisplaySequence'] = this.partyInterestDisplaySequence;
    if (Array.isArray(this.supportingEvidences)) {
      data['supportingEvidences'] = [];
      for (let item of this.supportingEvidences) data['supportingEvidences'].push(item.toJSON());
    }
    return data;
  }
}

export interface IInterestDto {
  id?: string;
  type?: string | undefined;
  status?: string | undefined;
  description?: string | undefined;
  partyInterestCapacity?: string | undefined;
  partyInterestStatus?: string | undefined;
  partyInterestDisplaySequence?: number;
  supportingEvidences?: SupportingEvidenceDto[] | undefined;
}

export class LandParcelDto implements ILandParcelDto {
  id?: string;
  numberOnPlan?: string | undefined;
  description?: string | undefined;
  interests?: InterestDto[] | undefined;

  constructor(data?: ILandParcelDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.numberOnPlan = _data['numberOnPlan'];
      this.description = _data['description'];
      if (Array.isArray(_data['interests'])) {
        this.interests = [] as any;
        for (let item of _data['interests']) this.interests!.push(InterestDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): LandParcelDto {
    data = typeof data === 'object' ? data : {};
    let result = new LandParcelDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['numberOnPlan'] = this.numberOnPlan;
    data['description'] = this.description;
    if (Array.isArray(this.interests)) {
      data['interests'] = [];
      for (let item of this.interests) data['interests'].push(item.toJSON());
    }
    return data;
  }
}

export interface ILandParcelDto {
  id?: string;
  numberOnPlan?: string | undefined;
  description?: string | undefined;
  interests?: InterestDto[] | undefined;
}

export class ClientsDto2 implements IClientsDto2 {
  id?: string;
  name?: string | undefined;

  constructor(data?: IClientsDto2) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): ClientsDto2 {
    data = typeof data === 'object' ? data : {};
    let result = new ClientsDto2();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    return data;
  }
}

export interface IClientsDto2 {
  id?: string;
  name?: string | undefined;
}

export class ProjectsDto implements IProjectsDto {
  id?: string;
  name?: string | undefined;
  status?: string | undefined;
  client?: ClientsDto2;
  webMapAPIKey?: string | undefined;
  lastRefreshedDate?: Date;

  constructor(data?: IProjectsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.status = _data['status'];
      this.client = _data['client'] ? ClientsDto2.fromJS(_data['client']) : <any>undefined;
      this.webMapAPIKey = _data['webMapAPIKey'];
      this.lastRefreshedDate = _data['lastRefreshedDate']
        ? new Date(_data['lastRefreshedDate'].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): ProjectsDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProjectsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['status'] = this.status;
    data['client'] = this.client ? this.client.toJSON() : <any>undefined;
    data['webMapAPIKey'] = this.webMapAPIKey;
    data['lastRefreshedDate'] = this.lastRefreshedDate ? this.lastRefreshedDate.toISOString() : <any>undefined;
    return data;
  }
}

export interface IProjectsDto {
  id?: string;
  name?: string | undefined;
  status?: string | undefined;
  client?: ClientsDto2;
  webMapAPIKey?: string | undefined;
  lastRefreshedDate?: Date;
}

export class ProjectCreateDto implements IProjectCreateDto {
  id?: string;
  clientId?: string;
  reference?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  orderType?: string | undefined;
  acquiringAuthority?: string | undefined;
  startDate?: Date | undefined;
  lastRefreshedDate?: Date;
  osLicenceNumber?: string | undefined;
  status?: string | undefined;
  sqlConnectionString?: string | undefined;
  webMapAPIKey?: string | undefined;
  documentStorageURL?: string | undefined;
  documentStorageContainer?: string | undefined;

  constructor(data?: IProjectCreateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.clientId = _data['clientId'];
      this.reference = _data['reference'];
      this.name = _data['name'];
      this.description = _data['description'];
      this.orderType = _data['orderType'];
      this.acquiringAuthority = _data['acquiringAuthority'];
      this.startDate = _data['startDate'] ? new Date(_data['startDate'].toString()) : <any>undefined;
      this.lastRefreshedDate = _data['lastRefreshedDate']
        ? new Date(_data['lastRefreshedDate'].toString())
        : <any>undefined;
      this.osLicenceNumber = _data['osLicenceNumber'];
      this.status = _data['status'];
      this.sqlConnectionString = _data['sqlConnectionString'];
      this.webMapAPIKey = _data['webMapAPIKey'];
      this.documentStorageURL = _data['documentStorageURL'];
      this.documentStorageContainer = _data['documentStorageContainer'];
    }
  }

  static fromJS(data: any): ProjectCreateDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProjectCreateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['clientId'] = this.clientId;
    data['reference'] = this.reference;
    data['name'] = this.name;
    data['description'] = this.description;
    data['orderType'] = this.orderType;
    data['acquiringAuthority'] = this.acquiringAuthority;
    data['startDate'] = this.startDate ? this.startDate.toISOString() : <any>undefined;
    data['lastRefreshedDate'] = this.lastRefreshedDate ? this.lastRefreshedDate.toISOString() : <any>undefined;
    data['osLicenceNumber'] = this.osLicenceNumber;
    data['status'] = this.status;
    data['sqlConnectionString'] = this.sqlConnectionString;
    data['webMapAPIKey'] = this.webMapAPIKey;
    data['documentStorageURL'] = this.documentStorageURL;
    data['documentStorageContainer'] = this.documentStorageContainer;
    return data;
  }
}

export interface IProjectCreateDto {
  id?: string;
  clientId?: string;
  reference?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  orderType?: string | undefined;
  acquiringAuthority?: string | undefined;
  startDate?: Date | undefined;
  lastRefreshedDate?: Date;
  osLicenceNumber?: string | undefined;
  status?: string | undefined;
  sqlConnectionString?: string | undefined;
  webMapAPIKey?: string | undefined;
  documentStorageURL?: string | undefined;
  documentStorageContainer?: string | undefined;
}

export class ProjectUpdateDto implements IProjectUpdateDto {
  reference?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  orderType?: string | undefined;
  acquiringAuthority?: string | undefined;
  osLicenceNumber?: string | undefined;
  status?: string | undefined;
  sqlConnectionString?: string | undefined;
  webMapAPIKey?: string | undefined;
  documentStorageURL?: string | undefined;
  documentStorageContainer?: string | undefined;

  constructor(data?: IProjectUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.reference = _data['reference'];
      this.name = _data['name'];
      this.description = _data['description'];
      this.orderType = _data['orderType'];
      this.acquiringAuthority = _data['acquiringAuthority'];
      this.osLicenceNumber = _data['osLicenceNumber'];
      this.status = _data['status'];
      this.sqlConnectionString = _data['sqlConnectionString'];
      this.webMapAPIKey = _data['webMapAPIKey'];
      this.documentStorageURL = _data['documentStorageURL'];
      this.documentStorageContainer = _data['documentStorageContainer'];
    }
  }

  static fromJS(data: any): ProjectUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProjectUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['reference'] = this.reference;
    data['name'] = this.name;
    data['description'] = this.description;
    data['orderType'] = this.orderType;
    data['acquiringAuthority'] = this.acquiringAuthority;
    data['osLicenceNumber'] = this.osLicenceNumber;
    data['status'] = this.status;
    data['sqlConnectionString'] = this.sqlConnectionString;
    data['webMapAPIKey'] = this.webMapAPIKey;
    data['documentStorageURL'] = this.documentStorageURL;
    data['documentStorageContainer'] = this.documentStorageContainer;
    return data;
  }
}

export interface IProjectUpdateDto {
  reference?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  orderType?: string | undefined;
  acquiringAuthority?: string | undefined;
  osLicenceNumber?: string | undefined;
  status?: string | undefined;
  sqlConnectionString?: string | undefined;
  webMapAPIKey?: string | undefined;
  documentStorageURL?: string | undefined;
  documentStorageContainer?: string | undefined;
}

export class RolesDto implements IRolesDto {
  id?: string;
  name?: string | undefined;

  constructor(data?: IRolesDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): RolesDto {
    data = typeof data === 'object' ? data : {};
    let result = new RolesDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    return data;
  }
}

export interface IRolesDto {
  id?: string;
  name?: string | undefined;
}

export class UsersDto implements IUsersDto {
  id?: string;
  externalReference?: string;
  name?: string | undefined;
  email?: string | undefined;
  role?: RolesDto;

  constructor(data?: IUsersDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.externalReference = _data['externalReference'];
      this.name = _data['name'];
      this.email = _data['email'];
      this.role = _data['role'] ? RolesDto.fromJS(_data['role']) : <any>undefined;
    }
  }

  static fromJS(data: any): UsersDto {
    data = typeof data === 'object' ? data : {};
    let result = new UsersDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['externalReference'] = this.externalReference;
    data['name'] = this.name;
    data['email'] = this.email;
    data['role'] = this.role ? this.role.toJSON() : <any>undefined;
    return data;
  }
}

export interface IUsersDto {
  id?: string;
  externalReference?: string;
  name?: string | undefined;
  email?: string | undefined;
  role?: RolesDto;
}

export class ProjectUserCreateDto implements IProjectUserCreateDto {
  externalReference?: string;
  name?: string | undefined;
  email?: string | undefined;
  roleId?: string;

  constructor(data?: IProjectUserCreateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.externalReference = _data['externalReference'];
      this.name = _data['name'];
      this.email = _data['email'];
      this.roleId = _data['roleId'];
    }
  }

  static fromJS(data: any): ProjectUserCreateDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProjectUserCreateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['externalReference'] = this.externalReference;
    data['name'] = this.name;
    data['email'] = this.email;
    data['roleId'] = this.roleId;
    return data;
  }
}

export interface IProjectUserCreateDto {
  externalReference?: string;
  name?: string | undefined;
  email?: string | undefined;
  roleId?: string;
}

export enum Severity {
  _0 = 0,
  _1 = 1,
  _2 = 2,
}

export class ValidationFailure implements IValidationFailure {
  propertyName?: string | undefined;
  errorMessage?: string | undefined;
  attemptedValue?: any | undefined;
  customState?: any | undefined;
  severity?: Severity;
  errorCode?: string | undefined;
  formattedMessageArguments?: any[] | undefined;
  formattedMessagePlaceholderValues?: { [key: string]: any } | undefined;
  resourceName?: string | undefined;

  constructor(data?: IValidationFailure) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.propertyName = _data['propertyName'];
      this.errorMessage = _data['errorMessage'];
      this.attemptedValue = _data['attemptedValue'];
      this.customState = _data['customState'];
      this.severity = _data['severity'];
      this.errorCode = _data['errorCode'];
      if (Array.isArray(_data['formattedMessageArguments'])) {
        this.formattedMessageArguments = [] as any;
        for (let item of _data['formattedMessageArguments']) this.formattedMessageArguments!.push(item);
      }
      if (_data['formattedMessagePlaceholderValues']) {
        this.formattedMessagePlaceholderValues = {} as any;
        for (let key in _data['formattedMessagePlaceholderValues']) {
          if (_data['formattedMessagePlaceholderValues'].hasOwnProperty(key))
            this.formattedMessagePlaceholderValues![key] = _data['formattedMessagePlaceholderValues'][key];
        }
      }
      this.resourceName = _data['resourceName'];
    }
  }

  static fromJS(data: any): ValidationFailure {
    data = typeof data === 'object' ? data : {};
    let result = new ValidationFailure();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['propertyName'] = this.propertyName;
    data['errorMessage'] = this.errorMessage;
    data['attemptedValue'] = this.attemptedValue;
    data['customState'] = this.customState;
    data['severity'] = this.severity;
    data['errorCode'] = this.errorCode;
    if (Array.isArray(this.formattedMessageArguments)) {
      data['formattedMessageArguments'] = [];
      for (let item of this.formattedMessageArguments) data['formattedMessageArguments'].push(item);
    }
    if (this.formattedMessagePlaceholderValues) {
      data['formattedMessagePlaceholderValues'] = {};
      for (let key in this.formattedMessagePlaceholderValues) {
        if (this.formattedMessagePlaceholderValues.hasOwnProperty(key))
          data['formattedMessagePlaceholderValues'][key] = this.formattedMessagePlaceholderValues[key];
      }
    }
    data['resourceName'] = this.resourceName;
    return data;
  }
}

export interface IValidationFailure {
  propertyName?: string | undefined;
  errorMessage?: string | undefined;
  attemptedValue?: any | undefined;
  customState?: any | undefined;
  severity?: Severity;
  errorCode?: string | undefined;
  formattedMessageArguments?: any[] | undefined;
  formattedMessagePlaceholderValues?: { [key: string]: any } | undefined;
  resourceName?: string | undefined;
}

export class ValidationResult implements IValidationResult {
  readonly isValid?: boolean;
  readonly errors?: ValidationFailure[] | undefined;
  readonly ruleSetsExecuted?: string[] | undefined;

  constructor(data?: IValidationResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      (<any>this).isValid = _data['isValid'];
      if (Array.isArray(_data['errors'])) {
        (<any>this).errors = [] as any;
        for (let item of _data['errors']) (<any>this).errors!.push(ValidationFailure.fromJS(item));
      }
      if (Array.isArray(_data['ruleSetsExecuted'])) {
        (<any>this).ruleSetsExecuted = [] as any;
        for (let item of _data['ruleSetsExecuted']) (<any>this).ruleSetsExecuted!.push(item);
      }
    }
  }

  static fromJS(data: any): ValidationResult {
    data = typeof data === 'object' ? data : {};
    let result = new ValidationResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['isValid'] = this.isValid;
    if (Array.isArray(this.errors)) {
      data['errors'] = [];
      for (let item of this.errors) data['errors'].push(item.toJSON());
    }
    if (Array.isArray(this.ruleSetsExecuted)) {
      data['ruleSetsExecuted'] = [];
      for (let item of this.ruleSetsExecuted) data['ruleSetsExecuted'].push(item);
    }
    return data;
  }
}

export interface IValidationResult {
  isValid?: boolean;
  errors?: ValidationFailure[] | undefined;
  ruleSetsExecuted?: string[] | undefined;
}

export class ProblemDetails implements IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  constructor(data?: IProblemDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data['type'];
      this.title = _data['title'];
      this.status = _data['status'];
      this.detail = _data['detail'];
      this.instance = _data['instance'];
    }
  }

  static fromJS(data: any): ProblemDetails {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['type'] = this.type;
    data['title'] = this.title;
    data['status'] = this.status;
    data['detail'] = this.detail;
    data['instance'] = this.instance;
    return data;
  }
}

export interface IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;
}

export class ProjectDto implements IProjectDto {
  id?: string;
  name?: string | undefined;
  description?: string | undefined;
  status?: string | undefined;
  startDate?: Date;
  lastRefreshedDate?: Date;
  client?: ClientsDto2;

  constructor(data?: IProjectDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.description = _data['description'];
      this.status = _data['status'];
      this.startDate = _data['startDate'] ? new Date(_data['startDate'].toString()) : <any>undefined;
      this.lastRefreshedDate = _data['lastRefreshedDate']
        ? new Date(_data['lastRefreshedDate'].toString())
        : <any>undefined;
      this.client = _data['client'] ? ClientsDto2.fromJS(_data['client']) : <any>undefined;
    }
  }

  static fromJS(data: any): ProjectDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProjectDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['description'] = this.description;
    data['status'] = this.status;
    data['startDate'] = this.startDate ? this.startDate.toISOString() : <any>undefined;
    data['lastRefreshedDate'] = this.lastRefreshedDate ? this.lastRefreshedDate.toISOString() : <any>undefined;
    data['client'] = this.client ? this.client.toJSON() : <any>undefined;
    return data;
  }
}

export interface IProjectDto {
  id?: string;
  name?: string | undefined;
  description?: string | undefined;
  status?: string | undefined;
  startDate?: Date;
  lastRefreshedDate?: Date;
  client?: ClientsDto2;
}

export class LandParcelListDto implements ILandParcelListDto {
  id?: string;
  numberOnPlan?: string | undefined;
  area?: number;

  constructor(data?: ILandParcelListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.numberOnPlan = _data['numberOnPlan'];
      this.area = _data['area'];
    }
  }

  static fromJS(data: any): LandParcelListDto {
    data = typeof data === 'object' ? data : {};
    let result = new LandParcelListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['numberOnPlan'] = this.numberOnPlan;
    data['area'] = this.area;
    return data;
  }
}

export interface ILandParcelListDto {
  id?: string;
  numberOnPlan?: string | undefined;
  area?: number;
}

export class PartyListDto implements IPartyListDto {
  id?: string;
  principalName?: string | undefined;
  isOrganisation?: boolean;
  topo?: string | undefined;
  salutation?: string | undefined;
  title?: string | undefined;
  status?: string | undefined;
  area?: number;

  constructor(data?: IPartyListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.principalName = _data['principalName'];
      this.isOrganisation = _data['isOrganisation'];
      this.topo = _data['topo'];
      this.salutation = _data['salutation'];
      this.title = _data['title'];
      this.status = _data['status'];
      this.area = _data['area'];
    }
  }

  static fromJS(data: any): PartyListDto {
    data = typeof data === 'object' ? data : {};
    let result = new PartyListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['principalName'] = this.principalName;
    data['isOrganisation'] = this.isOrganisation;
    data['topo'] = this.topo;
    data['salutation'] = this.salutation;
    data['title'] = this.title;
    data['status'] = this.status;
    data['area'] = this.area;
    return data;
  }
}

export interface IPartyListDto {
  id?: string;
  principalName?: string | undefined;
  isOrganisation?: boolean;
  topo?: string | undefined;
  salutation?: string | undefined;
  title?: string | undefined;
  status?: string | undefined;
  area?: number;
}

export class PartyDto2 implements IPartyDto2 {
  count?: number;
  list?: PartyListDto[] | undefined;

  constructor(data?: IPartyDto2) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.count = _data['count'];
      if (Array.isArray(_data['list'])) {
        this.list = [] as any;
        for (let item of _data['list']) this.list!.push(PartyListDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PartyDto2 {
    data = typeof data === 'object' ? data : {};
    let result = new PartyDto2();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['count'] = this.count;
    if (Array.isArray(this.list)) {
      data['list'] = [];
      for (let item of this.list) data['list'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPartyDto2 {
  count?: number;
  list?: PartyListDto[] | undefined;
}

export class DocumentDto implements IDocumentDto {
  count?: number;

  constructor(data?: IDocumentDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.count = _data['count'];
    }
  }

  static fromJS(data: any): DocumentDto {
    data = typeof data === 'object' ? data : {};
    let result = new DocumentDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['count'] = this.count;
    return data;
  }
}

export interface IDocumentDto {
  count?: number;
}

export class SupportingEvidenceListDto implements ISupportingEvidenceListDto {
  name?: string | undefined;
  direction?: string | undefined;
  count?: number;

  constructor(data?: ISupportingEvidenceListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.direction = _data['direction'];
      this.count = _data['count'];
    }
  }

  static fromJS(data: any): SupportingEvidenceListDto {
    data = typeof data === 'object' ? data : {};
    let result = new SupportingEvidenceListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['direction'] = this.direction;
    data['count'] = this.count;
    return data;
  }
}

export interface ISupportingEvidenceListDto {
  name?: string | undefined;
  direction?: string | undefined;
  count?: number;
}

export class SupportingEvidenceDto2 implements ISupportingEvidenceDto2 {
  count?: number;
  list?: SupportingEvidenceListDto[] | undefined;

  constructor(data?: ISupportingEvidenceDto2) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.count = _data['count'];
      if (Array.isArray(_data['list'])) {
        this.list = [] as any;
        for (let item of _data['list']) this.list!.push(SupportingEvidenceListDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): SupportingEvidenceDto2 {
    data = typeof data === 'object' ? data : {};
    let result = new SupportingEvidenceDto2();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['count'] = this.count;
    if (Array.isArray(this.list)) {
      data['list'] = [];
      for (let item of this.list) data['list'].push(item.toJSON());
    }
    return data;
  }
}

export interface ISupportingEvidenceDto2 {
  count?: number;
  list?: SupportingEvidenceListDto[] | undefined;
}

export class LandParcelDto2 implements ILandParcelDto2 {
  count?: number;
  area?: number;
  list?: LandParcelListDto[] | undefined;
  parties?: PartyDto2;
  documents?: DocumentDto;
  supportingEvidence?: SupportingEvidenceDto2;

  constructor(data?: ILandParcelDto2) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.count = _data['count'];
      this.area = _data['area'];
      if (Array.isArray(_data['list'])) {
        this.list = [] as any;
        for (let item of _data['list']) this.list!.push(LandParcelListDto.fromJS(item));
      }
      this.parties = _data['parties'] ? PartyDto2.fromJS(_data['parties']) : <any>undefined;
      this.documents = _data['documents'] ? DocumentDto.fromJS(_data['documents']) : <any>undefined;
      this.supportingEvidence = _data['supportingEvidence']
        ? SupportingEvidenceDto2.fromJS(_data['supportingEvidence'])
        : <any>undefined;
    }
  }

  static fromJS(data: any): LandParcelDto2 {
    data = typeof data === 'object' ? data : {};
    let result = new LandParcelDto2();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['count'] = this.count;
    data['area'] = this.area;
    if (Array.isArray(this.list)) {
      data['list'] = [];
      for (let item of this.list) data['list'].push(item.toJSON());
    }
    data['parties'] = this.parties ? this.parties.toJSON() : <any>undefined;
    data['documents'] = this.documents ? this.documents.toJSON() : <any>undefined;
    data['supportingEvidence'] = this.supportingEvidence ? this.supportingEvidence.toJSON() : <any>undefined;
    return data;
  }
}

export interface ILandParcelDto2 {
  count?: number;
  area?: number;
  list?: LandParcelListDto[] | undefined;
  parties?: PartyDto2;
  documents?: DocumentDto;
  supportingEvidence?: SupportingEvidenceDto2;
}

export class ProjectOverviewDto implements IProjectOverviewDto {
  project?: ProjectDto;
  landParcels?: LandParcelDto2;

  constructor(data?: IProjectOverviewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.project = _data['project'] ? ProjectDto.fromJS(_data['project']) : <any>undefined;
      this.landParcels = _data['landParcels'] ? LandParcelDto2.fromJS(_data['landParcels']) : <any>undefined;
    }
  }

  static fromJS(data: any): ProjectOverviewDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProjectOverviewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['project'] = this.project ? this.project.toJSON() : <any>undefined;
    data['landParcels'] = this.landParcels ? this.landParcels.toJSON() : <any>undefined;
    return data;
  }
}

export interface IProjectOverviewDto {
  project?: ProjectDto;
  landParcels?: LandParcelDto2;
}

export class PartyDto3 implements IPartyDto3 {
  id?: string;
  reference?: string | undefined;
  clientReference?: string | undefined;
  principalName?: string | undefined;
  isOrganisation?: boolean;
  title?: string | undefined;
  salutation?: string | undefined;
  topo?: string | undefined;
  termFoundIn?: string | undefined;

  constructor(data?: IPartyDto3) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.reference = _data['reference'];
      this.clientReference = _data['clientReference'];
      this.principalName = _data['principalName'];
      this.isOrganisation = _data['isOrganisation'];
      this.title = _data['title'];
      this.salutation = _data['salutation'];
      this.topo = _data['topo'];
      this.termFoundIn = _data['termFoundIn'];
    }
  }

  static fromJS(data: any): PartyDto3 {
    data = typeof data === 'object' ? data : {};
    let result = new PartyDto3();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['reference'] = this.reference;
    data['clientReference'] = this.clientReference;
    data['principalName'] = this.principalName;
    data['isOrganisation'] = this.isOrganisation;
    data['title'] = this.title;
    data['salutation'] = this.salutation;
    data['topo'] = this.topo;
    data['termFoundIn'] = this.termFoundIn;
    return data;
  }
}

export interface IPartyDto3 {
  id?: string;
  reference?: string | undefined;
  clientReference?: string | undefined;
  principalName?: string | undefined;
  isOrganisation?: boolean;
  title?: string | undefined;
  salutation?: string | undefined;
  topo?: string | undefined;
  termFoundIn?: string | undefined;
}

export class ParcelDto implements IParcelDto {
  id?: string;
  reference?: string | undefined;
  clientReference?: string | undefined;
  numberOnPlan?: string | undefined;
  description?: string | undefined;

  constructor(data?: IParcelDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.reference = _data['reference'];
      this.clientReference = _data['clientReference'];
      this.numberOnPlan = _data['numberOnPlan'];
      this.description = _data['description'];
    }
  }

  static fromJS(data: any): ParcelDto {
    data = typeof data === 'object' ? data : {};
    let result = new ParcelDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['reference'] = this.reference;
    data['clientReference'] = this.clientReference;
    data['numberOnPlan'] = this.numberOnPlan;
    data['description'] = this.description;
    return data;
  }
}

export interface IParcelDto {
  id?: string;
  reference?: string | undefined;
  clientReference?: string | undefined;
  numberOnPlan?: string | undefined;
  description?: string | undefined;
}

export class SupportingEvidenceDto3 implements ISupportingEvidenceDto3 {
  id?: string;
  reference?: string | undefined;
  clientReference?: string | undefined;
  supportingEvidenceReference?: string | undefined;
  description?: string | undefined;
  direction?: string | undefined;
  date?: Date;

  constructor(data?: ISupportingEvidenceDto3) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.reference = _data['reference'];
      this.clientReference = _data['clientReference'];
      this.supportingEvidenceReference = _data['supportingEvidenceReference'];
      this.description = _data['description'];
      this.direction = _data['direction'];
      this.date = _data['date'] ? new Date(_data['date'].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): SupportingEvidenceDto3 {
    data = typeof data === 'object' ? data : {};
    let result = new SupportingEvidenceDto3();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['reference'] = this.reference;
    data['clientReference'] = this.clientReference;
    data['supportingEvidenceReference'] = this.supportingEvidenceReference;
    data['description'] = this.description;
    data['direction'] = this.direction;
    data['date'] = this.date ? this.date.toISOString() : <any>undefined;
    return data;
  }
}

export interface ISupportingEvidenceDto3 {
  id?: string;
  reference?: string | undefined;
  clientReference?: string | undefined;
  supportingEvidenceReference?: string | undefined;
  description?: string | undefined;
  direction?: string | undefined;
  date?: Date;
}

export class SearchDto implements ISearchDto {
  parties?: PartyDto3[] | undefined;
  parcels?: ParcelDto[] | undefined;
  supportingEvidences?: SupportingEvidenceDto3[] | undefined;

  constructor(data?: ISearchDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['parties'])) {
        this.parties = [] as any;
        for (let item of _data['parties']) this.parties!.push(PartyDto3.fromJS(item));
      }
      if (Array.isArray(_data['parcels'])) {
        this.parcels = [] as any;
        for (let item of _data['parcels']) this.parcels!.push(ParcelDto.fromJS(item));
      }
      if (Array.isArray(_data['supportingEvidences'])) {
        this.supportingEvidences = [] as any;
        for (let item of _data['supportingEvidences'])
          this.supportingEvidences!.push(SupportingEvidenceDto3.fromJS(item));
      }
    }
  }

  static fromJS(data: any): SearchDto {
    data = typeof data === 'object' ? data : {};
    let result = new SearchDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.parties)) {
      data['parties'] = [];
      for (let item of this.parties) data['parties'].push(item.toJSON());
    }
    if (Array.isArray(this.parcels)) {
      data['parcels'] = [];
      for (let item of this.parcels) data['parcels'].push(item.toJSON());
    }
    if (Array.isArray(this.supportingEvidences)) {
      data['supportingEvidences'] = [];
      for (let item of this.supportingEvidences) data['supportingEvidences'].push(item.toJSON());
    }
    return data;
  }
}

export interface ISearchDto {
  parties?: PartyDto3[] | undefined;
  parcels?: ParcelDto[] | undefined;
  supportingEvidences?: SupportingEvidenceDto3[] | undefined;
}

export class DocumentsDto2 implements IDocumentsDto2 {
  id?: string;
  reference?: string | undefined;
  clientReference?: string | undefined;
  type?: string | undefined;
  version?: string | undefined;
  documentURL?: string | undefined;

  constructor(data?: IDocumentsDto2) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.reference = _data['reference'];
      this.clientReference = _data['clientReference'];
      this.type = _data['type'];
      this.version = _data['version'];
      this.documentURL = _data['documentURL'];
    }
  }

  static fromJS(data: any): DocumentsDto2 {
    data = typeof data === 'object' ? data : {};
    let result = new DocumentsDto2();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['reference'] = this.reference;
    data['clientReference'] = this.clientReference;
    data['type'] = this.type;
    data['version'] = this.version;
    data['documentURL'] = this.documentURL;
    return data;
  }
}

export interface IDocumentsDto2 {
  id?: string;
  reference?: string | undefined;
  clientReference?: string | undefined;
  type?: string | undefined;
  version?: string | undefined;
  documentURL?: string | undefined;
}

export class SupportingEvidencesDto2 implements ISupportingEvidencesDto2 {
  id?: string;
  reference?: string | undefined;
  clientReference?: string | undefined;
  supportingEvidenceReference?: string | undefined;
  description?: string | undefined;
  version?: string | undefined;
  type?: string | undefined;
  direction?: string | undefined;
  date?: Date;
  documents?: DocumentsDto2[] | undefined;

  constructor(data?: ISupportingEvidencesDto2) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.reference = _data['reference'];
      this.clientReference = _data['clientReference'];
      this.supportingEvidenceReference = _data['supportingEvidenceReference'];
      this.description = _data['description'];
      this.version = _data['version'];
      this.type = _data['type'];
      this.direction = _data['direction'];
      this.date = _data['date'] ? new Date(_data['date'].toString()) : <any>undefined;
      if (Array.isArray(_data['documents'])) {
        this.documents = [] as any;
        for (let item of _data['documents']) this.documents!.push(DocumentsDto2.fromJS(item));
      }
    }
  }

  static fromJS(data: any): SupportingEvidencesDto2 {
    data = typeof data === 'object' ? data : {};
    let result = new SupportingEvidencesDto2();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['reference'] = this.reference;
    data['clientReference'] = this.clientReference;
    data['supportingEvidenceReference'] = this.supportingEvidenceReference;
    data['description'] = this.description;
    data['version'] = this.version;
    data['type'] = this.type;
    data['direction'] = this.direction;
    data['date'] = this.date ? this.date.toISOString() : <any>undefined;
    if (Array.isArray(this.documents)) {
      data['documents'] = [];
      for (let item of this.documents) data['documents'].push(item.toJSON());
    }
    return data;
  }
}

export interface ISupportingEvidencesDto2 {
  id?: string;
  reference?: string | undefined;
  clientReference?: string | undefined;
  supportingEvidenceReference?: string | undefined;
  description?: string | undefined;
  version?: string | undefined;
  type?: string | undefined;
  direction?: string | undefined;
  date?: Date;
  documents?: DocumentsDto2[] | undefined;
}

export class SupportingEvidenceDto4 implements ISupportingEvidenceDto4 {
  id?: string;
  direction?: string | undefined;
  supportingEvidenceReference?: string | undefined;

  constructor(data?: ISupportingEvidenceDto4) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.direction = _data['direction'];
      this.supportingEvidenceReference = _data['supportingEvidenceReference'];
    }
  }

  static fromJS(data: any): SupportingEvidenceDto4 {
    data = typeof data === 'object' ? data : {};
    let result = new SupportingEvidenceDto4();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['direction'] = this.direction;
    data['supportingEvidenceReference'] = this.supportingEvidenceReference;
    return data;
  }
}

export interface ISupportingEvidenceDto4 {
  id?: string;
  direction?: string | undefined;
  supportingEvidenceReference?: string | undefined;
}

export class InterestDto2 implements IInterestDto2 {
  id?: string;
  type?: string | undefined;
  status?: string | undefined;
  description?: string | undefined;
  partyInterestCapacity?: string | undefined;
  partyInterestStatus?: string | undefined;
  partyInterestDisplaySequence?: number;
  supportingEvidences?: SupportingEvidenceDto4[] | undefined;

  constructor(data?: IInterestDto2) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.type = _data['type'];
      this.status = _data['status'];
      this.description = _data['description'];
      this.partyInterestCapacity = _data['partyInterestCapacity'];
      this.partyInterestStatus = _data['partyInterestStatus'];
      this.partyInterestDisplaySequence = _data['partyInterestDisplaySequence'];
      if (Array.isArray(_data['supportingEvidences'])) {
        this.supportingEvidences = [] as any;
        for (let item of _data['supportingEvidences'])
          this.supportingEvidences!.push(SupportingEvidenceDto4.fromJS(item));
      }
    }
  }

  static fromJS(data: any): InterestDto2 {
    data = typeof data === 'object' ? data : {};
    let result = new InterestDto2();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['type'] = this.type;
    data['status'] = this.status;
    data['description'] = this.description;
    data['partyInterestCapacity'] = this.partyInterestCapacity;
    data['partyInterestStatus'] = this.partyInterestStatus;
    data['partyInterestDisplaySequence'] = this.partyInterestDisplaySequence;
    if (Array.isArray(this.supportingEvidences)) {
      data['supportingEvidences'] = [];
      for (let item of this.supportingEvidences) data['supportingEvidences'].push(item.toJSON());
    }
    return data;
  }
}

export interface IInterestDto2 {
  id?: string;
  type?: string | undefined;
  status?: string | undefined;
  description?: string | undefined;
  partyInterestCapacity?: string | undefined;
  partyInterestStatus?: string | undefined;
  partyInterestDisplaySequence?: number;
  supportingEvidences?: SupportingEvidenceDto4[] | undefined;
}

export class AddressesDto2 implements IAddressesDto2 {
  id?: string;
  addressLine1?: string | undefined;
  addressLine2?: string | undefined;
  addressLine3?: string | undefined;
  addressLine4?: string | undefined;
  addressLine5?: string | undefined;
  addressLine6?: string | undefined;
  postalTown?: string | undefined;
  postCode?: string | undefined;
  country?: string | undefined;
  status?: string | undefined;
  type?: string | undefined;

  constructor(data?: IAddressesDto2) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.addressLine1 = _data['addressLine1'];
      this.addressLine2 = _data['addressLine2'];
      this.addressLine3 = _data['addressLine3'];
      this.addressLine4 = _data['addressLine4'];
      this.addressLine5 = _data['addressLine5'];
      this.addressLine6 = _data['addressLine6'];
      this.postalTown = _data['postalTown'];
      this.postCode = _data['postCode'];
      this.country = _data['country'];
      this.status = _data['status'];
      this.type = _data['type'];
    }
  }

  static fromJS(data: any): AddressesDto2 {
    data = typeof data === 'object' ? data : {};
    let result = new AddressesDto2();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['addressLine1'] = this.addressLine1;
    data['addressLine2'] = this.addressLine2;
    data['addressLine3'] = this.addressLine3;
    data['addressLine4'] = this.addressLine4;
    data['addressLine5'] = this.addressLine5;
    data['addressLine6'] = this.addressLine6;
    data['postalTown'] = this.postalTown;
    data['postCode'] = this.postCode;
    data['country'] = this.country;
    data['status'] = this.status;
    data['type'] = this.type;
    return data;
  }
}

export interface IAddressesDto2 {
  id?: string;
  addressLine1?: string | undefined;
  addressLine2?: string | undefined;
  addressLine3?: string | undefined;
  addressLine4?: string | undefined;
  addressLine5?: string | undefined;
  addressLine6?: string | undefined;
  postalTown?: string | undefined;
  postCode?: string | undefined;
  country?: string | undefined;
  status?: string | undefined;
  type?: string | undefined;
}

export class PartySupportingEvidenceDto implements IPartySupportingEvidenceDto {
  id?: string;
  projectId?: string;
  reference?: string | undefined;
  principalName?: string | undefined;
  salutation?: string | undefined;
  isOrganisation?: boolean;
  title?: string | undefined;
  topo?: string | undefined;
  status?: string | undefined;
  interests?: InterestDto2[] | undefined;
  addresses?: AddressesDto2[] | undefined;

  constructor(data?: IPartySupportingEvidenceDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.projectId = _data['projectId'];
      this.reference = _data['reference'];
      this.principalName = _data['principalName'];
      this.salutation = _data['salutation'];
      this.isOrganisation = _data['isOrganisation'];
      this.title = _data['title'];
      this.topo = _data['topo'];
      this.status = _data['status'];
      if (Array.isArray(_data['interests'])) {
        this.interests = [] as any;
        for (let item of _data['interests']) this.interests!.push(InterestDto2.fromJS(item));
      }
      if (Array.isArray(_data['addresses'])) {
        this.addresses = [] as any;
        for (let item of _data['addresses']) this.addresses!.push(AddressesDto2.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PartySupportingEvidenceDto {
    data = typeof data === 'object' ? data : {};
    let result = new PartySupportingEvidenceDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['projectId'] = this.projectId;
    data['reference'] = this.reference;
    data['principalName'] = this.principalName;
    data['salutation'] = this.salutation;
    data['isOrganisation'] = this.isOrganisation;
    data['title'] = this.title;
    data['topo'] = this.topo;
    data['status'] = this.status;
    if (Array.isArray(this.interests)) {
      data['interests'] = [];
      for (let item of this.interests) data['interests'].push(item.toJSON());
    }
    if (Array.isArray(this.addresses)) {
      data['addresses'] = [];
      for (let item of this.addresses) data['addresses'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPartySupportingEvidenceDto {
  id?: string;
  projectId?: string;
  reference?: string | undefined;
  principalName?: string | undefined;
  salutation?: string | undefined;
  isOrganisation?: boolean;
  title?: string | undefined;
  topo?: string | undefined;
  status?: string | undefined;
  interests?: InterestDto2[] | undefined;
  addresses?: AddressesDto2[] | undefined;
}

export class TimelinesDto implements ITimelinesDto {
  id?: string;
  title?: string | undefined;
  description?: string | undefined;
  type?: string | undefined;
  date?: Date;

  constructor(data?: ITimelinesDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.title = _data['title'];
      this.description = _data['description'];
      this.type = _data['type'];
      this.date = _data['date'] ? new Date(_data['date'].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): TimelinesDto {
    data = typeof data === 'object' ? data : {};
    let result = new TimelinesDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['title'] = this.title;
    data['description'] = this.description;
    data['type'] = this.type;
    data['date'] = this.date ? this.date.toISOString() : <any>undefined;
    return data;
  }
}

export interface ITimelinesDto {
  id?: string;
  title?: string | undefined;
  description?: string | undefined;
  type?: string | undefined;
  date?: Date;
}

export class TimelineCreateUpdateDto implements ITimelineCreateUpdateDto {
  title?: string | undefined;
  description?: string | undefined;
  type?: string | undefined;
  date?: Date;

  constructor(data?: ITimelineCreateUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.title = _data['title'];
      this.description = _data['description'];
      this.type = _data['type'];
      this.date = _data['date'] ? new Date(_data['date'].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): TimelineCreateUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new TimelineCreateUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['title'] = this.title;
    data['description'] = this.description;
    data['type'] = this.type;
    data['date'] = this.date ? this.date.toISOString() : <any>undefined;
    return data;
  }
}

export interface ITimelineCreateUpdateDto {
  title?: string | undefined;
  description?: string | undefined;
  type?: string | undefined;
  date?: Date;
}

export class Body implements IBody {
  file?: any | undefined;

  constructor(data?: IBody) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.file = _data['file'];
    }
  }

  static fromJS(data: any): Body {
    data = typeof data === 'object' ? data : {};
    let result = new Body();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['file'] = this.file;
    return data;
  }
}

export interface IBody {
  file?: any | undefined;
}

export class Body2 implements IBody2 {
  file?: any | undefined;

  constructor(data?: IBody2) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.file = _data['file'];
    }
  }

  static fromJS(data: any): Body2 {
    data = typeof data === 'object' ? data : {};
    let result = new Body2();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['file'] = this.file;
    return data;
  }
}

export interface IBody2 {
  file?: any | undefined;
}

export class SwaggerResponse<TResult> {
  status: number;
  headers: { [key: string]: any };
  result: TResult;

  constructor(status: number, headers: { [key: string]: any }, result: TResult) {
    this.status = status;
    this.headers = headers;
    this.result = result;
  }
}

export interface FileParameter {
  data: any;
  fileName: string;
}

export interface FileResponse {
  data: Blob;
  status: number;
  fileName?: string;
  headers?: { [name: string]: any };
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}

/**
 * Configuration class needed in base class.
 * The config is provided to the API client at initialization time.
 * API clients inherit from #AuthorizedApiBase and provide the config.
 */

let _pca: PublicClientApplication;
export const setPca = (pca: PublicClientApplication) => {
  _pca = pca;
};
